<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <div>
        <div v-if='btns.add'>
          <button :title='$t("MCS.addUser")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("add")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-add e-icons"></span>
          </button>
        </div>
        <div v-if='btns.mod'>
          <button :title='$t("MCS.modUser")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("mod")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-edit e-icons"></span>
          </button>
        </div>
        <div v-if='btns.del'>
          <button :title='$t("MCS.del")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("del")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-batch-remove e-icons"></span>
          </button>
        </div>
        <div v-if='btns.groupList'>
          <button :title='$t("MCS.groupList")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("qryGroupList")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-grouplist e-icons"></span>
          </button>
        </div>
        <ejs-dropdownbutton :title='$t("MCS.blackList")' v-if='btns.blackList' :items='blackItems' iconCss='icon hero-icon hero-icon-blacklist' :select='dropDownBlackNum'></ejs-dropdownbutton>
        <ejs-dropdownbutton :title='$t("MCS.areaList")' v-if='btns.areaList' :items='areaItems' iconCss='icon hero-icon hero-icon-region' :select='dropDownAreaNum'></ejs-dropdownbutton>
        <div v-if='btns.export'>
          <button :title='$t("MCS.export")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("export")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-export e-icons"></span>
          </button>
        </div>
        <div v-if='btns.refresh'>
          <button :title='$t("MCS.refresh")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("refresh")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-refresh e-icons"></span>
          </button>
        </div>
        <div class="e-toolbar-item e-separator" aria-disabled="false"></div>
        <div v-if='btns.qry'>
          <button :title='$t("MCS.superSearch")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("search")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-search e-icons"></span>
          </button>
        </div>
      </div>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'UsersTableMenu',
  data() {
    return {
      btns: {
        add: true,
        mod: true,
        del: true,
        groupList: true,
        blackList: true,
        areaList: true,
        export: false,
        refresh: true,
        qry: true
      },
      blackItems: [
        {
          text: this.$t('MCS.addBlackNum'),
          value: 0
        },
        {
          text: this.$t('MCS.manageBlackNum'),
          value: 1
        }],
      areaItems: [
        {
          text: this.$t('MCS.addAreaNum'),
          value: 0
        },
        {
          text: this.$t('MCS.manageAreaNum'),
          value: 1
        }]
    };
  },
  methods: {
    buttonClk(args) {
      this.$emit('methodEnum', args);
    },
    dropDownBlackNum(it) {
      if (it.item.value === 0) {
        this.$emit('methodEnum', 'addBlackList');
      } else if (it.item.value === 1) {
        this.$emit('methodEnum', 'qryBlackList');
      }
    },
    dropDownAreaNum(it) {
      if (it.item.value === 0) {
        this.$emit('methodEnum', 'addAreaList');
      } else if (it.item.value === 1) {
        this.$emit('methodEnum', 'qryAreaList');
      }
    }
  }
};
</script>

<style scoped>

</style>
